import COASearchCard from "@/components/COASearchCard";

/**
 * Public Certificate of Analysis lookup page.
 *
 * No auth required — COAs are public regulatory documents. Designed so
 * that QR codes printed on each vial can deep-link straight here. Layout
 * is intentionally minimal: centered card, GLPFlo brand, a short
 * explainer line, and the lookup form.
 */
export default function CoaPublic() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="text-center mb-8">
          <p className="text-xs uppercase tracking-widest text-emerald-600 font-bold">GLPFlo · Pharmacy Transparency</p>
          <h1 className="mt-2 text-4xl sm:text-5xl font-extrabold text-slate-900">Verify your vial</h1>
          <p className="mt-3 text-base text-slate-600 max-w-xl mx-auto">
            Every batch of GLPFlo-distributed medication ships with a third-party Certificate of Analysis.
            Type the lot number from your vial label to download the lab report for that exact batch.
          </p>
        </div>
        <COASearchCard />
        <p className="mt-8 text-center text-xs text-slate-500">
          Can&apos;t find your lot? Log in and ask the chat bot — our care team will track it down for you.
        </p>
      </div>
    </div>
  );
}
